import React, {useEffect, useState, setGlobal, getGlobal, useContext} from 'reactn';
import moment from 'moment';
import Sidebar from '../Sidebar';
import {Redirect, useParams} from 'react-router-dom';
import {IdcardOutlined  } from '@ant-design/icons';

// import API from '../../Utils/api';
// import { Tabs } from 'antd';
import ChiefComplaints from '../../Components/ChiefComplaints';
import Examination from '../../Components/Examination';
import Vitals from '../../Components/Vitals';
import { Tabs, Button, Modal } from 'antd';
import Loader from '../../Components/Loader';
import { useFirestore } from 'reactfire';
import Investigation from '../../Components/Investigation';
import Diagnosis from '../../Components/Diagnosis';
import {StoreContext}  from '../../Context/store';
import Treatment from '../../Components/Treatment';
import PatientAppointmentHistory from '../../Components/PatientAppointmentHistory';


const AttendingPanel = () => {

    // const { TabPane } = Tabs;
    let {id} = useParams();
    let { appointmentId } = useParams();
    const [patient, setPatient] = useState();
    const [viewPatientModal, setviewPatientModal] = useState(false);
    const [appointment, setAppointment] = useState({});
    const firestore = useFirestore();
    const [appointmnt, setapmt] = useState({});
    const [redirect, serRedirect] = useState(false);
    const { TabPane } = Tabs;
    const query = firestore.collection("patients").doc(id);
    const query_appointments = firestore.collection("chief_complaints");

    const appointments_q = firestore.collection("appointments");
    const [itselfClose, madeIteSelfClose] = useState(false);
    const [loader, setLoader] = useState(false);
    const context = useContext(StoreContext);

    const getCurrentPatient = () => {
        query.get().then((response) => {
            setPatient(response.data());
            setGlobal({PatientDetails: response.data() ? response.data() : {}});
        });
    }
    const getCurrentAppointment = () => {
        appointments_q.doc(appointmentId).get().then((response) => {
            setAppointment(response.data());
            setGlobal({next_visit_date: response.data().nextVisit ? response.data().nextVisit : null})
            console.log('appointment is response.data() : ', response.data());
        });
    }
    const getCurrentComplaint = () => {
        setLoader(true);
        let records = [];
        query_appointments.where("appointment_id", "==", appointmentId).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
                // console.log('DOC is ',doc.data());
            });
            setGlobal({location: records.length > 0 ? records[0].data.location : getGlobal().location});
            setGlobal({chief_comp_id: records.length > 0 ? records[0].id : null});
            // console.log('Get the Appointntment complete: ',  );

            setapmt(records.length !== 0 ? records[0].data : null);
            setLoader(false);
            // console.log(records[0].location, getGlobal().location, 'this is cheif comp');
        });
    }

    useEffect(()=> {
        getCurrentPatient();
        getCurrentAppointment();
        getCurrentComplaint();
        setGlobal({
            patientID: id,
            appointmentId : appointmentId,
        });
        attendingAppointment();
    }, []);


    const cancelviewPatientModal = () => {
        setviewPatientModal(false);
      }

    const closeAppointment = () => {
        madeIteSelfClose(true);
        setLoader(true);

        appointments_q.doc(appointmentId).update({
            status: 'close',
        }).then(() => {
            serRedirect(true);
            setLoader(false);
        });
    }

    const pendingAppointment = () => {
        setLoader(true);
        appointments_q.doc(appointmentId).update({
            status: 'pending',
        }).then(() => {
            serRedirect(true);
            setLoader(false);
        });
    }

    const attendingAppointment = () => {
        appointments_q.doc(appointmentId).update({
            status: 'attending',
        }).then(() => {
        });
    }

    const dateDifferenceUsingMoment = (date1, date2) => {
        const m1 = moment(date1);
        const m2 = moment(date2);
    
        const diff = moment.duration(m2.diff(m1));
    
        const years = diff.years();
        const months = diff.months();
        const days = diff.days();
    
        return { years, months, days };
    }

    
    const age = patient && patient.DOB ? dateDifferenceUsingMoment(patient.DOB, new Date) : 0;

    return (
        <React.Fragment>
            {loader && <Loader />}
            {redirect && <Redirect to="/" />}
            <Sidebar showAppointments={false}/>
            <div className='container'>
                <div className="showUserInformation">
                    <ul>
                        <li>Token No: {appointment && appointment.token}</li>
                        <li>Patient Name: {patient && patient.fullName}</li>
                        {patient && patient.DOB && <li>Age: {(age.years && age.years + " Years ") + (age.months && age.months +  " Months ") + (age.days && age.days + " Days")}</li>}
                        {patient && patient.education && <li>Education: {patient.education}</li>}
                        {patient && patient.occupation && <li>Occupation: {Array.isArray(patient.occupation) ? patient.occupation.join(', ') : patient.occupation}</li>}
                        <h3><IdcardOutlined onClick={() => setviewPatientModal(true)}/></h3>
                    </ul>
                </div>
                <div className='appintment_statuses_handle'>
                    <Button onClick={pendingAppointment}>Make Appointment Pending</Button>
                    <Button onClick={closeAppointment}>Close Appointment</Button>
                </div>
                 
                <Modal
                    title="Patient's Full Information"
                    visible={viewPatientModal}
                    onCancel={cancelviewPatientModal}
                    footer={null}
                    >

                        <ul className='PatientDetailInfo'>
                            <li><strong>Patient Name: </strong> {patient && patient.fullName}</li>
                            <li><strong>Contact Number: </strong>{patient && patient.contactNumber}</li>
                            {patient && patient.DOB && <li><strong>Age: </strong>{(age.years && age.years + " Years ") + (age.months && age.months +  " Months ") + (age.days && age.days + " Days")}</li>}
                            {patient && patient.gender && <li><strong>Gender: </strong>{patient.gender}</li>}
                            {patient && patient.guardianName && <li><strong>Guardian Name: </strong>{patient.guardianName}</li>}
                            {patient && patient.education && <li><strong>Education: </strong>{patient.education}</li>}
                            {patient && patient.occupation && <li><strong>Occupation: </strong>{Array.isArray(patient.occupation) ? patient.occupation.join(', ') : patient.occupation}</li>}
                            {patient && patient.nationality && <li><strong>Nationality: </strong>{patient.nationality}</li>} 
                            {patient && patient.address && <li><strong>Address: </strong>{patient.address}</li>}
                            {patient && patient.MedicalHistory && <li><strong>Medical History: </strong>{patient.MedicalHistory.join(', ')}</li>}
                            {patient && patient.PastSugicalHistory && <li><strong>Past Sugical History: </strong>{patient.PastSugicalHistory.join(', ')}</li>}
                            {patient && patient.PersonalHistory && <li><strong>Personal History: </strong>{patient.PersonalHistory.join(', ')}</li>}
                            {patient && patient.AddictionHistory && <li><strong>Addiction History: </strong>{patient.AddictionHistory.join(', ')}</li>}
                            {patient && patient.HistoryofanyDrugAllergy && <li><strong>History of any Drug Allergy: </strong>{patient.HistoryofanyDrugAllergy.join(', ')}</li>}
                            {patient && patient.FamilyHistory && <li><strong>Family History: </strong>{patient.FamilyHistory.join(', ')}</li>}
                            
                            {patient && patient.note && <li><strong>Note: </strong>{patient.note}</li>}
                            
                        </ul>
                </Modal>


                <Tabs defaultActiveKey="1" type="card" style={{marginTop: '1px'}}>
                    <TabPane tab="Vitals" key="1">
                        <div className='main_section'>
                            <Vitals />
                        </div>
                    </TabPane>
                    <TabPane tab="Chief Complaints" key="2">
                        <div className='main_section'>
                            <ChiefComplaints />
                        </div>
                    </TabPane>
                    <TabPane tab="Examination" key="3">
                        <div className='main_section'>
                            <Examination />
                        </div>
                    </TabPane>
                    <TabPane tab="Investigation" key="4">
                        <div className='main_section'>
                            <Investigation />
                        </div>
                    </TabPane>
                    <TabPane tab="Diagnosis" key="5">
                        <div className='main_section'>
                            <Diagnosis />
                        </div>
                    </TabPane>
                    <TabPane tab="Treatments" key="6">
                        <div className='main_section'>
                            <Treatment />
                        </div>
                    </TabPane>
                    <TabPane tab="Appointment History" key="7">
                        <div className='main_section'>
                            <PatientAppointmentHistory />
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </React.Fragment>
    );
}

export default AttendingPanel;
